/**
 * Paths where the Intercom Chat widget should be hidden (no auth required).
 * All other routes (e.g. /support, dashboard, onboarding config) keep the widget.
 */
const INTERCOM_HIDDEN_PATH_PREDICATES: Array<(pathname: string) => boolean> = [
  (p) => p === '/terms' || p.startsWith('/terms/'),
  (p) => p === '/privacy' || p.startsWith('/privacy/'),
  (p) => p === '/book' || p.startsWith('/book/'),
  (p) => p.startsWith('/booking'),
  (p) => p.startsWith('/bookings'),
  (p) => p === '/onboarding/login',
  (p) => p === '/onboarding/login-with-token',
  (p) => p === '/onboarding/impersonate',
  (p) => p === '/confirmation' || p.startsWith('/confirmation/'),
  (p) => p === '/meet' || p.startsWith('/meet/'),
]

export function shouldShowIntercom(pathname: string): boolean {
  const isHidden = INTERCOM_HIDDEN_PATH_PREDICATES.some((fn) => fn(pathname))
  return !isHidden
}
